import { CreateSubscriptionDTO, ICancelSubscriptionVO, UpdatePaymentMethodVO } from "../model/PaymentModels";
import { ICreditCardInformations } from "../pages/AdminConsole/AccountAndSubscription/AccountAndSubscription";
import { Api, ApiWithoutToken } from "./api";

export async function CancelSubscription(input: ICancelSubscriptionVO) {
  const request = await Api.put("stripe/ScheduleUserSubscription", {
    data: input
  });

  return request.data;
}

export async function RealCancelSubscription(internalName: string) {
  const request = await Api.delete(`stripe/DeleteSubscription/${internalName}`);
  return request.data;
}

export async function CreateSubscription(input: CreateSubscriptionDTO) {
  const request = await ApiWithoutToken.post(`stripe/CreateSubscription`, input);
  return request.data;
}

export async function UpdatePaymentMethodAsync(input: UpdatePaymentMethodVO) {
    const request = await Api.put(`stripe/UpdatePaymentMethod`, input);
    return request.data;
}